module.exports = __webpack_public_path__ + "static/media/ic-terampil.b6fa4bba.svg";